import api from '@/api'

export default {
  // 获取球员列表-GET-可分页
  getPlayer (params) {
    return api({
      url: '/relevant/player',
      method: 'GET',
      params
    })
  },
  getPlayerSystem (params) {
    return api({
      url: '/player/playerListSystem',
      method: 'GET',
      params
    })
  },
  getPlayerOrgan (params) {
    return api({
      url: '/player/playerListOrgan',
      method: 'GET',
      params
    })
  },
  getPlayerYouth (params) {
    return api({
      url: '/player/playerListYouth',
      method: 'GET',
      params
    })
  },
  getPlayerLeaderOrCoach (params) {
    return api({
      url: '/integration/player/playerListCoachOrLeader',
      method: 'GET',
      params
    })
  },
  getPlayerByPlayer (params) {
    return api({
      url: '/player/playerListPlayer',
      method: 'GET',
      params
    })
  },
  // 添加球员员
  addPlayer (data) {
    return api({
      url: '/player/playerAdd',
      method: 'POST',
      data
    })
  },
  // 修改球员员信息
  updatePlayer (data) {
    return api({
      url: '/player/playerEdit',
      method: 'PUT',
      data
    })
  },
  // 查看球员员详细信息
  getPlayerInfo (uuid) {
    return api({
      url: `/integration/player/playerInfo/${uuid}`,
      method: 'GET'
    })
  },
  // 删除球员员
  deletePlayer (uuid) {
    return api({
      url: `/relevant/player/${uuid}`,
      method: 'DELETE'
    })
  },
  // 获取空闲球员
  getIdlePlayer (params) {
    return api({
      url: '/player/free_list',
      method: 'GET',
      params
    })
  },
  // 获取空闲球员 org
  getIdlePlayerByOrg (params) {
    return api({
      url: '/integration/player/freePlayerListOrgan',
      method: 'GET',
      params
    })
  },
  // 获取空闲球员 system
  getIdlePlayerBySystem (params) {
    return api({
      url: '/integration/player/freePlayerListSystem',
      method: 'GET',
      params
    })
  },
  // 获取空闲球员 youth
  getIdlePlayerByYouth (params) {
    return api({
      url: '/integration/player/freePlayerListYouth',
      method: 'GET',
      params
    })
  },

  // 获取空闲球员 coach
  getIdlePlayerByCoach (params) {
    return api({
      url: '/integration/player/freePlayerListCoach',
      method: 'GET',
      params
    })
  },

  // 获取球队下的球员
  getSquadPlayer (uuid) {
    return api({
      url: `/player/squadPlayerList/${uuid}`,
      method: 'GET'
    })
  },
  // 跟新球队下的球员
  updataSquadPlayer (data) {
    return api({
      url: '/integration/player/squadPlayerSave',
      method: 'POST',
      data
    })
  },
  // 批量添加球员
  batchAddLeader (data) {
    return api({
      url: '/player/import/excel',
      method: 'POST',
      data
    })
  },
  allPositionList (params) {
    return api({
      url: '/player/allPositionList',
      method: 'GET',
      params
    })
  },
  // 球员更换球队
  playerChangeSquad (data) {
    return api({
      url: '/integration/player/playerChangeSquad',
      method: 'POST',
      data
    })
  },
  // 球员更换球队
  trainListToPlayer (params) {
    return api({
      url: '/event/trainingPlanInfo/trainListToPlayer',
      method: 'GET',
      params
    })
  },
  // 关注/取消关注球员
  toChangePlayerFocusAction(data) {
    return api({
      url: '/player/playerFocus',
      method: 'POST',
      data
    })
  },
  // 获取球员关注记录
  findPlayerFocusRecord(playerUuid) {
    return api({
      url: `/player/playerFocusHistoryList/${playerUuid}`,
      method: 'POST',
    })
  },

    // 获取球员所在球队
  getPlayerSquadList(playerUuid) {
    return api({
      url: `/integration/player/playerToSquadList/${playerUuid}`,
      method: 'GET',
    })
  },

  // 下载球员列表
  getDownloadPlayerSystem (params) {
    return api({
      url: '/player/downloadPlayer',
      method: 'GET',
      params
    })
  },

}
